import { useMutation } from '@tanstack/react-query'

import { deleteCompletePageConditionalRuleById } from './services/deleteCompletePageConditionalRuleById'

export const useDeleteCompletePageConditionalRuleById = () => {
  const mutation = useMutation({
    mutationFn: async (id: string) =>
      await deleteCompletePageConditionalRuleById(id),
  })

  const deleteCompletePageConditionalRuleByIdReq = async (id: string) => {
    return mutation.mutateAsync(id)
  }

  return {
    deleteCompletePageConditionalRuleById:
      deleteCompletePageConditionalRuleByIdReq,
    ...mutation,
  }
}
